import {hasNumber, hasSymbol, hasObviousSequence} from './PasswordValidations';

export const buildPasswordRules = (settings: any) => {
  const rules = [];

  if (settings.pwdRequireMinLength) {
    rules.push({
      key: 'length',
      label: `Al menos ${settings.pwdMinLength} caracteres`,
      test: (v: string) => (v?.length ?? 0) >= settings.pwdMinLength,
    });
  }

  if (settings.pwdRequireNumber) {
    rules.push({
      key: 'number',
      label: 'Contiene al menos un número',
      test: (v: string) => hasNumber(v),
    });
  }

  if (settings.pwdRequireSymbol) {
    rules.push({
      key: 'symbol',
      label: 'Contiene al menos un símbolo',
      test: (v: string) => hasSymbol(v),
    });
  }

  if (settings.pwdDisallowObviousSequences) {
    rules.push({
      key: 'no-obvious',
      label: 'No contiene secuencias obvias',
      test: (v: string) => !hasObviousSequence(v),
    });
  }

  if (settings.pwdDisallowUserData) {
    rules.push({
      key: 'no-personal',
      label: 'No contiene datos personales',
      test: (v: string, ctx: any) => {
        if (!v) return true;

        const value = v.toLowerCase();
        const {cwid, name, email} = ctx;

        if (cwid && value.includes(cwid.toLowerCase())) return false;
        if (email && value.includes(email.toLowerCase())) return false;

        if (name) {
          const parts = name.toLowerCase().split(' ');
          if (parts.some((p: string) => p.length > 2 && value.includes(p))) {
            return false;
          }
        }

        return true;
      },
    });
  }

  return rules;
};
